export default __webpack_public_path__ + "static/media/indxfocus.5ac5df35.svg";